import { ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

interface PortalProps {
	children: ReactNode
}

/**
 * Компонент для рендеринга children в body через React Portal
 * Используется для дропдаунов чтобы избежать проблем с z-index и overflow
 */
const Portal: React.FC<PortalProps> = ({ children }) => {
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)
		return () => setMounted(false)
	}, [])

	if (!mounted) return null

	return createPortal(children, document.body)
}

export default Portal
